// Port of api/fuel/app/classes/controller/api/monty/patreon/change.php
// Write endpoint - guarded by offline router
export default function() {
	return Promise.reject({ error: 'This action is not available offline.', offline: true })
}
